import { STATUS } from "@/constants/statuses";
import { Store, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

export interface ShopifyDiscountState {
    discountStatus: Record<number | string, STATUS>;
}

const createInitialState = (): ShopifyDiscountState => ({
    discountStatus: {},
});

@singleton()
@StoreConfig({ name: "ShopifyDiscountStore" })
class ShopifyDiscountStore extends Store<ShopifyDiscountState> {
    constructor() {
        super(createInitialState());
    }

    setDiscountStatus(status: STATUS, itemId: number | string): void {
        this.update((state) => ({
            ...state,
            discountStatus: { [itemId]: status },
        }));
    }
}

export default ShopifyDiscountStore;
